import React from "react"
import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from "react-sortable-hoc";

import Icon from "@alboompro/boom-components/general/icon";

import { DragComponent, DragIcon } from "./styles";

export const DragHandle = sortableHandle(() => (
  <DragIcon>
    <Icon 
      kind="bold" 
      group="arrows-diagrams" 
      category="diagrams" 
      file="diagram-all-direction-expand.svg" 
      size="14" 
      color="#000000"
    />
  </DragIcon>
));

export const SortableItem = sortableElement(({ children }) => (
  <DragComponent>{children}</DragComponent>
));

export const SortableContainer = sortableContainer(({ children }) => {
  return <div>{children}</div>;
});